export default __webpack_public_path__ + "static/media/plus.21f353b9.svg";